import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = "BZD", decimals = 2) {
  return new Intl.NumberFormat("en-BZ", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(amount);
}

// For tons with 4 decimal places
export function formatCaneRate(amount) {
  return new Intl.NumberFormat("en-BZ", {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  }).format(amount);
}


export function formatTonRate(amount, currency = "BZD") {
  return new Intl.NumberFormat("en-BZ", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatNumber(num, decimals = 2) {
  return new Intl.NumberFormat("en-BZ", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num);
}

export function formatNumber4(num) {
  return new Intl.NumberFormat("en-BZ", {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  }).format(num);
}

export function formatDate(dateString) {
  // Handle YYYY-MM-DD format without timezone conversion
  if (dateString && dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
    const [year, month, day] = dateString.split('-');
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    return date.toLocaleDateString("en-BZ", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }
  // For ISO strings with time component
  return new Date(dateString).toLocaleDateString("en-BZ", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatDateTime(dateString) {
  return new Date(dateString).toLocaleString("en-BZ", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function getStatusColor(status) {
  const colors = {
    draft: "status-draft",
    reviewed: "status-reviewed",
    approved: "status-approved",
    paid: "status-paid",
    reversed: "status-reversed",
  };
  return colors[status] || "status-draft";
}

export function getWorkerTypeLabel(type) {
  const labels = {
    cane_cutter: "Cane Cutter",
    field_personnel: "Field Personnel",
    boss: "Group Leader",
    grabman: "Grabman",
    driver: "Driver",
  };
  return labels[type] || type;
}

export function calculateGrossPay(tons, ratePerTon) {
  return Math.round(tons * ratePerTon * 100) / 100;
}

export function calculateSSB(grossPay, ssbRules) {
  if (!ssbRules || !ssbRules.brackets) {
    return { employee: 0, employer: 0, total: 0 };
  }

  let employeeSSB = 0;
  let employerSSB = 0;

  for (const bracket of ssbRules.brackets) {
    if (grossPay >= bracket.min_income && grossPay <= bracket.max_income) {
      employeeSSB = grossPay * (bracket.employee_rate / 100);
      employerSSB = grossPay * (bracket.employer_rate / 100);
      break;
    }
  }

  // If no bracket matched, use the highest bracket
  if (employeeSSB === 0 && employerSSB === 0 && ssbRules.brackets.length > 0) {
    const highest = ssbRules.brackets[ssbRules.brackets.length - 1];
    if (grossPay > highest.max_income) {
      employeeSSB = grossPay * (highest.employee_rate / 100);
      employerSSB = grossPay * (highest.employer_rate / 100);
    }
  }

  return {
    employee: Math.round(employeeSSB * 100) / 100,
    employer: Math.round(employerSSB * 100) / 100,
    total: Math.round((employeeSSB + employerSSB) * 100) / 100,
  };
}

export function calculateNetPay(grossPay, ssbEmployee, otherDeductions) {
  return Math.round((grossPay - ssbEmployee - otherDeductions) * 100) / 100;
}

export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export function generateId() {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
}
